import { BaseModel } from '../../_base/crud';
import { Shipment } from './shipment.model';

export class InvoiceCheckReport extends BaseModel {
  id: number;
  date_created: Date;
  charged_returns: Array<Shipment>;
  kg_diffs: Array<Shipment>;
  inv_kg_diffs: Array<Shipment>;
  not_found: Array<string>;
  cad_log: Array<any>;
}
